import * as React from 'react';
import gql from 'graphql-tag';
import { ChildProps, graphql, compose } from 'react-apollo';
import { any } from 'bluebird';

const InvoicesQuery = gql`
  query invoices($orderId: String!) {
    invoices(orderId: $orderId) {
      id
      invoiceNumber
      type
      createdAt
      freshbooksData
      invoiceDate
      dueDate
      taxableDate
      sourceFile
      quickbooksData

      currency {
        id
        value
      }
    }
  }
`;

const SendInvoiceMutation = gql`
  mutation sendInvoice($id: String!) {
    sendInvoice(id: $id) {
      id
    }
  }
`;

const DeleteInvoiceMutation = gql`
  mutation deleteInvoice($id: String!) {
    deleteInvoice(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface Response {
  data: any;
}

class GetInvoicesQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  public render() {
    const { invoices, publishToFreshbooks, sendInvoice, deleteInvoice }: any = this.props;
    return this.props.children({ invoices, publishToFreshbooks, sendInvoice, deleteInvoice });
  }
}

export default compose(
  graphql<any, Response>(InvoicesQuery, {
    name: 'invoices',
    options: props => ({
      variables: { orderId: props.orderId },
      fetchPolicy: 'network-only'
    })
  }),
  graphql<any, Response>(SendInvoiceMutation, {
    name: 'sendInvoice',
  }),
  graphql<any, Response>(DeleteInvoiceMutation, {
    name: 'deleteInvoice',
  }),
)(GetInvoicesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Invoices/Invoices.tsx